import service from './service.js';


export class FAQService {

    getFaqs(pLang) {

        //returns Promise object
        return service.getRestClient().post('/api/getFAQ', JSON.stringify({
            language: pLang,
        }));
    }
}

export default (new FAQService());